export const validateShippingPostcode = ({
  shippingAddress,
  basketPostcode,
}: {
  shippingAddress?: paypal.AuthorizationResponseDetails['shippingAddress']
  basketPostcode: string
}) => {
  const normalisedBasketPostcode = basketPostcode.trim().toUpperCase()
  const normalisedShippingPostcode = shippingAddress?.postalCode.trim().toUpperCase()

  const isPostcodeValid = normalisedShippingPostcode === normalisedBasketPostcode

  return {
    isValid: isPostcodeValid,
    error: isPostcodeValid ? '' : 'PayPal wallet postcode does not match the basket postcode',
  }
}
